const MA1 = [
    {id: "5", value: "5日"},   
    {id: "10", value: "10日"},       
    {id: "20", value: "20日"},
    {id: "60", value: "60日"},
    {id: "120", value: "120日"},
  ];  
  
  export default MA1  